import {
  IClearSignUpFieldsAction,
  ISetIsSigningUpAction,
  ISetSignUpCallingCodeAction,
  ISetSignUpCountryAction,
  ISetSignUpDNIAction,
  ISetSignUpEmailAction,
  ISetSignUpLastNameAction,
  ISetSignUpNameAction,
  ISetSignUpPasswordAction,
  ISetSignUpPhoneAction,
  ISetSignUpTermsAndConditionsAction,
  ISignUpAction,
  ISignUpFailedAction,
  ISignUpSuccessfulAction,
  IToggleCountryPickerModalAction,
  SignUpTypeKeys
} from '../types'

export function clearSignUpFieldsAction(): IClearSignUpFieldsAction {
  return { type: SignUpTypeKeys.CLEAR_SIGN_UP_FIELDS }
}

export function setSignUpEmailAction(email: string): ISetSignUpEmailAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_EMAIL, payload: email }
}

export function setSignUpPasswordAction(password: string): ISetSignUpPasswordAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_PASSWORD, payload: password }
}

export function setSignUpNameAction(name: string): ISetSignUpNameAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_NAME, payload: name }
}

export function setSignUpLastNameAction(lastName: string): ISetSignUpLastNameAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_LAST_NAME, payload: lastName }
}

export function setSignUpDNIAction(dni: string): ISetSignUpDNIAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_DNI, payload: dni }
}

export function setSignUpPhoneAction(phone: string): ISetSignUpPhoneAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_PHONE, payload: phone }
}

export function setSignUpCountryAction(country: any): ISetSignUpCountryAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_COUNTRY, payload: country }
}

export function setSignUpCallingCodeAction(callingCode: string): ISetSignUpCallingCodeAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_CALLING_CODE, payload: callingCode }
}

export function setToggleCountryPickerModalAction(): IToggleCountryPickerModalAction {
  return { type: SignUpTypeKeys.TOGGLE_COUNTRY_PICKER_MODAL }
}

export function setSignUpTermsAndConditionsAction(): ISetSignUpTermsAndConditionsAction {
  return { type: SignUpTypeKeys.SET_SIGN_UP_TERMS }
}

export function signUpAction(): ISignUpAction {
  return { type: SignUpTypeKeys.SIGN_UP }
}

export function setIsSigningUpAction(): ISetIsSigningUpAction {
  return { type: SignUpTypeKeys.SIGNING_UP }
}

export function signUpSuccessfulAction(): ISignUpSuccessfulAction {
  return { type: SignUpTypeKeys.SIGN_UP_SUCCESSFUL }
}

export function signUpFailedAction(payload: any): ISignUpFailedAction {
  return { type: SignUpTypeKeys.SIGN_UP_FAILED, payload }
}
